import React, { useState } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../Sidebar/Sidebar";
import { useLocation } from "react-router-dom";
import DevicesList from "./DevicesList.jsx";

const Dashboard = () => {
  let Location = useLocation();
  const { user } = useSelector((state) => ({ ...state.auth }));
  const [searchText, setSearchText] = useState("");

  return (
    <>
      <Sidebar
        element={
          <>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row my-2">
                    <div className="d-flex justify-content-between align-items-center gap-5">
                      <div className="my-5">
                        <h3 style={{ width: "max-content" }} className="blue-text font_weight">
                          Welcome {user?.name}
                        </h3>
                      </div>
                      <div className="input-group">
                        <input type="text" className="form-control py-2" placeholder="Search Devices by ID" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <DevicesList searchText={searchText} />
            </div>
          </>
        }
      />
    </>
  );
};

export default Dashboard;
